import {Survey} from '../../features/company/culture/surveys/types/SurveyTypes';

export const findCurrentSurvey = (surveys: Survey[]): Survey | undefined => {
  return surveys.find((survey) => {
    if (survey.startedAt) {
      const startedAtDate = new Date(survey.startedAt);

      // Set hours, minutes, seconds, and milliseconds to zero
      startedAtDate.setHours(0, 0, 0, 0);

      const currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0);

      return startedAtDate <= currentDate;
    }

    return false;
  });
};
